




















import CashbackForm from '@/components/Cashback/CForm.vue';
import { tCashbackParams, tNewCashback } from '@/store/interfaces/cashback';
import cashback from '@/store/types/cashback';
import { TeipNotifications } from '@/util/teipNotifications';
import { navLink } from '@/ts/navegationLinks';
import { mapActions } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'UpdateCashback',
  components: {
    CashbackForm,
  },
  data: () => ({
    navlink: [
      {
        name: 'Cashbacks',
        active: false,
        to: '/noveltiesAndPromotions/cashback/',
      },
      {
        name: 'Actualizar cashback',
        active: true,
      }
    ] as navLink[],
    cashback: null as tCashbackParams | null,
  }),
  mounted(): void {
    this.getSingleCashback({ id: this.$route.params.id, })
      .then((cashback) => {
        this.cashback = cashback.data.data;
      }).catch(() => {
        const notification = new TeipNotifications();
        notification.warning(':(', 'Cashback no encontrado, o hubo un error al cargarlo');

        this.$router.push('/noveltiesAndPromotions/cashback/');
      });
  },
  methods: {
    ...mapActions({
      updateCashbackAction: `cashback/${cashback.actions.UPDATE_CASHBACK}`,
      getSingleCashback: `cashback/${cashback.actions.SINGLE_CASHBACK}`,
    }),
    async updateCashback(cashback: tNewCashback): Promise<void> {
      const notification = new TeipNotifications();
      this.updateCashbackAction({ data: cashback, id: this.$route.params.id, })
        .then(() => {
          notification.success(':)', 'Cashback actualizado exitosamente');
          this.$router.push('/noveltiesAndPromotions/cashback/');
        })
        .catch(() => {
          notification.warning(':(', 'Error al actualizar el cashback');
        });
    },
  },
});
